class Sticky {
    constructor() {
        this.topElement = document.querySelector('.iz-to-top');
        this.sharingElement = document.querySelector('.iz-to-top-sharing');

        if (this.topElement && this.sharingElement) {
            this.init();
        }
    }

    init() {
        window.addEventListener('scroll', () => this.handleScroll());
    }

    handleScroll() {
        // Add visible class when scrolled past 200px
        if (window.scrollY > 200) {
            this.topElement.classList.add('visible');
        } else {
            this.topElement.classList.remove('visible');
        }

        // Check if sharing element is in viewport
        const sharingRect = this.sharingElement.getBoundingClientRect();
        if (sharingRect.top >= 0 && sharingRect.bottom <= window.innerHeight) {
            this.topElement.classList.add('non-sticky');
        } else {
            this.topElement.classList.remove('non-sticky');
        }
    }
}

export default Sticky;